import React from "react";
import { BsArrowRight } from "react-icons/bs";
import { Link } from "react-router-dom";
import horizontal from "../images/horizontal.png";

const AboutMeDesktop = () => {
	return (
		<>
			<div
				style={{
					display: "flex",
					flexDirection: "row ",
					alignItems: "center",
					width: "90%",
					margin: "10% auto 2% auto",
				}}
			>
				<span style={{ color: "#C778DD" }}>#</span>
				<h3 style={{ color: "white", fontWeight: "bolder" }}>About-me</h3>
				<img src={horizontal} alt="" style={{ width: "20%", height: "auto" }} />
			</div>

			<div
				style={{
					width: "90%",
					margin: "0 auto",
					display: "flex",
					flexDirection: "column",
					justifyContent: "start",
					textAlign: "justify",
					textJustify: "auto",
					hyphens: "auto",
					// wordBreak: "break-word",
					color: "#ABB2BF",
					textJustify: "inter-word",
					//   alignItems: "start",
				}}
			>
				<p>
					Hello <span style={{ fontWeight: "bolder" }}>I'm Mayowa!</span>
				</p>
				<p style={{ width: "60%", margin: "2% 0" }}>
					I am a Blockchain and Full-Stack Developer. I have extensive knowledge
					in Blockchain technology and i am skilled in developing web
					applications from the front-end to the back-end. My focus lies in
					utilizing my capabilities to develop innovative applications that
					effectively solve real-world challenges.
				</p>
				<p style={{ width: "60%", margin: "2% 0" }}>
					I am Proficeint in React, Express JS, Node JS, Mongo DB and Solidity,
					i have experience working with Ethereum, Avalanche, polygon and
					Binance Smart Chain.. I am an expert in developing smart contracts and
					decentralized applications (dApps). I am committed to staying
					up-to-date with emerging blockchain technologies and driving
					innovation. I am a strong collaborator and dedicated to
					revolutionizing industries with transparent and secure solutions.
				</p>
			</div>
		</>
	);
};

export default AboutMeDesktop;
